// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    if (!burgerButton) return;

    burgerButton.addEventListener('click', function () {
        document.body.classList.toggle('gh-head-open');
        const expanded = document.body.classList.contains('gh-head-open');
        burgerButton.setAttribute('aria-expanded', expanded);
    });

    document.querySelectorAll('.gh-nav-wrap a').forEach((link) => {
        link.addEventListener('click', () => {
            document.body.classList.remove('gh-head-open');
            burgerButton.setAttribute('aria-expanded', 'false');
        });
    });
}